<div class="Login d-flex justify-content-center align-items-center">
  <div class="row layout-login">
    <div class="col-md-6 d-flex justify-content-center align-items-center bgLoginLogo">
      <img src="assets/images/logo/login.svg" class="logo w-50 smallScreenHide py-3" alt="logo">
    </div>

    <div class="col-md-6 bgForm">

      <section class="container">
        <div class="py-5">
          <div class="text-center pb-4">
            <img src="assets/images/login@2x.png" class="w-25 smallScreenHide m-auto" alt="logo">
            <img src="assets/images/logo/smalllogin.svg" class="mb-4 logo smallScreenShow m-auto" alt="logo">
            <h2 class="SignUp">{{"Login.login" | translate}}</h2>
          </div>
          <form [formGroup]="loginForm" (ngSubmit)="submitLoginForm(loginForm)">
            <div class="mt-2">
              <label for="email">{{'Register.email' | translate}}</label>
              <input formControlName="email" (click)='onFocus()' placeholder="example@gmail.com" id="email" type="email"
                class="form-control mt-2">
              <div *ngIf="loginFormControl['email'].touched && loginFormControl['email'].invalid"
                class="mt-2 text-danger">
                <div *ngIf="loginFormControl['email'].errors && loginFormControl['email'].errors['required']">
                  {{"Login.emailRequired" | translate}}</div>
                <div *ngIf="loginFormControl['email'].errors && loginFormControl['email'].errors['email']">
                  {{"Login.emailinvalid" | translate}}</div>
              </div>
            </div>
            
            <div class="mt-2">
              <div class="form-group">
                <label>{{"Login.password" | translate}}</label>
                <mat-form-field appearance="outline">
                  <input matInput class="py-1" formControlName="password" (click)='onFocus()'
                    type="{{showPassword ? 'text' : 'password'}}" placeholder='{{"Login.password" | translate}}'>
                  <mat-icon matSuffix>
                    <span (click)='showHidePassword()' class="btn-code">
                      <i *ngIf="!showPassword" class="fa-regular fa-eye"></i>
                      <i *ngIf="showPassword" class="fa-regular fa-eye-slash"></i>
                    </span>
                  </mat-icon>
                </mat-form-field>

                <div *ngIf="loginFormControl['password'].touched && loginFormControl['password'].invalid"
                  class="text-danger mt-2">
                  <div *ngIf="loginFormControl['password'].errors && loginFormControl['password'].errors['required']">
                    {{"Login.passwordrequired" | translate}}
                  </div>
                </div>
              </div>
            </div>

            <button class="btn commonButton w-100 my-3" type="submit" [disabled]="!loginForm.valid">
              <i class='fas fa-spinner fa-spin' *ngIf="isLoading"></i>
              <span *ngIf="!isLoading">{{"Login.login" | translate}}</span>
            </button>
            <div *ngIf='error' class="alert-danger mb-2 py-1">
              <h4 class="text-center text-danger fw-bold">{{error}}</h4>
            </div>

          </form>
        </div>
      </section>
    </div>
  </div>
</div>